import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteItem, getAllItems } from "../../../redux/slices/dynamicUiSlice";
import AddItemLoader, { AddItemError } from "./AddItemLoader";
import DynamicItemTableHeader from "./DynamicItemTableHeader";
import CustomTable from "../../../components/table/CustomTable";
import DynamicItemTableBody from "./DynamicItemTableBody";
import { ITEM_PER_PAGE_DYNAMIC_ITEMS } from "../constants";
import ConfirmModal from "../../../components/ConfirmModal";
import { PreviewModal } from "./PreviewModal";
import AddToSelectedModal from "./AddToSelectedModal";
import useDidMount from "../../../hooks/useDidMount";

export default function DynamicItemListContents({ onEditItem }) {

  const activeTab = useSelector((state) => (state.dynamicUi.items.activeTab));
  const selectedTab = useSelector((state) => (state.dynamicUi.items[activeTab].selected));
  const { deleting, deleteFlag } = useSelector((state) => state.dynamicUi.items.flags);
  const [itemClicked, setItemClicked] = useState();
  const [itemToSelected, setItemToSelected] = useState();

  // const {loading, init, error} = useSelector((state) => state.dynamicUi.items[selectedTab]);
  const currentPage = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta.page);

  const {
    loading,
    error,
    init
  } = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].pageData[currentPage]) ?? { loading: false, init: false };

  const dispatch = useDispatch();


  const fetchAllItems = useCallback(() => {
    dispatch(getAllItems());
  }, [dispatch]);

  useEffect(() => {
    if (!init && !loading && !error) {
      fetchAllItems();
    }
  }, [init, fetchAllItems, loading, error, activeTab]);

  const removeItem = () => {
    dispatch(deleteItem(itemClicked.id));
  };

  const closeModal = () => {
    setItemClicked(undefined);
  };

  const onPreviewAction = (item) => {
    setItemClicked(undefined);
    setItemToSelected(item);
  };

  useDidMount(() => {
    closeModal();
  }, [deleteFlag]);


  return (
    <>
      {
        error ? <AddItemError errorMsg={error} retry={fetchAllItems} /> :
          <CustomTable>
            <DynamicItemTableHeader />
            {/*{loading ? <AddItemLoader/> : <DynamicItemTableBody onEditItem={setShowAddItemModal}/>}*/}

            {loading || !init ? <AddItemLoader count={ITEM_PER_PAGE_DYNAMIC_ITEMS} /> :
              <DynamicItemTableBody onEditItem={onEditItem} setItemToSelected={setItemToSelected}
                setItemClicked={setItemClicked} />}
            <tbody>
              <tr>
                <td>
                  <ConfirmModal showModal={!!itemClicked?.delete} onConfirm={removeItem} setShowModal={closeModal}
                    disabled={deleting}>
                    This element will be deleted
                </ConfirmModal>
                  <PreviewModal showModal={!!itemClicked?.preview ? itemClicked : undefined}
                    setShowModal={closeModal} add={true} onConfirm={onPreviewAction} />
                  <AddToSelectedModal showModal={itemToSelected} setShowModal={setItemToSelected} />
                </td>
              </tr>
            </tbody>

          </CustomTable>
      }
    </>
  );
}


